import ApplicationSerializer from 'lumen/serializers/application';

export default class MarketPerformanceDataItemSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'subscription_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('market-performance/data-item');
    }

    if (key === 'subscriptions') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('market-performance/subscription');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }
}
